import React from "react";
import styles from "./style.module.css";
import { formatMoneyNumber } from "../../../../utils/util";
import { useTranslation } from "react-i18next";

const MyTotalLoan = ({
  totalLoanAmount,
  totalPaidPrincipal,
  totalPaidInterest,
  totalDebtAmount,
}) => {
  const { t, i18n } = useTranslation('myLoan');
  return (
    <section className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.title}>{t('myLoan')}</h1>
      </header>
      <div className={styles.content}>
        <div className={styles.card}>
          <h2 className={styles.cardTitle}>{t('overAll')}</h2>
          <div className={styles.loanSummary}>
            <div className={styles.row}>
              <span className={styles.loanTitle}>{t('sumLoan')}</span>
              <span className={styles.loanValue}>
                {formatMoneyNumber(totalLoanAmount)}
              </span>
            </div>
            <div className={styles.row}>
              <span className={styles.loanTitle}>{t('allDepositPaid')}</span>
              <span className={styles.loanValue}>
                {formatMoneyNumber(totalPaidPrincipal)}
              </span>
            </div>
            <div className={styles.row}>
              <span className={styles.loanTitle}>{t('allInterestPaid')}</span>
              <span className={styles.loanValue}>
                {formatMoneyNumber(totalPaidInterest)}
              </span>
            </div>
            <div className={styles.row}>
              <span className={styles.loanTitle}>{t('allNotPaid')}</span>
              <span className={styles.remaining}>
                {formatMoneyNumber(totalDebtAmount)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyTotalLoan;
